var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.8 27.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M9.4,2A2.21,2.21,0,0,0,7.1,0,2.15,2.15,0,0,0,4.8,2,2.09,2.09,0,0,0,7.1,4,2.15,2.15,0,0,0,9.4,2M28.6,9.4c3.1,2.2,3.2,5.4,3.2,7.9v10H28v-10c0-2.6,0-4.2-1.6-5.4a5.88,5.88,0,0,0-5-.5c-2.7,1.1-3.2,3.1-3.8,6.3,0,.2-.1.3-.1.5-.5,2.7-1,5.4-3.8,7.5a10.68,10.68,0,0,1-6,1.9,6.93,6.93,0,0,1-2-.3,7.27,7.27,0,0,1-5-3.8A10.88,10.88,0,0,1,0,21.1c1.5,3.1,5.2,3.6,8.2,3.1A7,7,0,0,0,11.6,23c1.9-1.3,2.3-3.5,2.7-5.9.5-3.2,1.2-7,5.9-8.8a9.88,9.88,0,0,1,8.4,1.1M5.2,7.8a8.23,8.23,0,0,1-1.3,5.5c-.3.5-.6,1-.8,1.4s-.3.5-.5.8A15.29,15.29,0,0,0,.9,18.2,1.42,1.42,0,0,0,1,19.3,7,7,0,0,0,4.2,22c-.6-1.7-.1-2.6,1.2-4.6l.2-.3a3.51,3.51,0,0,1,.5-.8c.3-.5.6-1,1-1.6A12,12,0,0,0,8.8,7.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.f68e70e5da8efcd52fcdbd348c45b209.svg";
export { ForwardRef as ReactComponent };